export const sortingMixin = {
    data() {
        return {
            sorting: {
                list: [],
                fieldName: "",
                fieldType: "",
                fieldFunction: null,
                isAscending: true
            }
        };
    },

    computed: {
        sortedList() {
            if (this.sorting.fieldType === "string") {
                if (this.sorting.isAscending) {
                    return this.sorting.list.sort((e1, e2) => this.$_sortingMixin_getColumnElement(e1).localeCompare(this.$_sortingMixin_getColumnElement(e2)));
                } else {
                    return this.sorting.list.sort((e1, e2) => this.$_sortingMixin_getColumnElement(e2).localeCompare(this.$_sortingMixin_getColumnElement(e1)));
                }
            }

            if (this.sorting.fieldType === "date") {
                if (this.sorting.isAscending) {
                    return this.sorting.list.sort((e1, e2) => (new Date(this.$_sortingMixin_getColumnElement(e1))).valueOf() - (new Date(this.$_sortingMixin_getColumnElement(e2))).valueOf());
                } else {
                    return this.sorting.list.sort((e1, e2) => (new Date(this.$_sortingMixin_getColumnElement(e2))).valueOf() - (new Date(this.$_sortingMixin_getColumnElement(e1))).valueOf());
                }
            }

            if (this.sorting.fieldType === "number") {
                if (this.sorting.isAscending) {
                    return this.sorting.list.sort((e1, e2) => this.$_sortingMixin_getColumnElement(e1) - this.$_sortingMixin_getColumnElement(e2));
                } else {
                    return this.sorting.list.sort((e1, e2) => this.$_sortingMixin_getColumnElement(e2) - this.$_sortingMixin_getColumnElement(e1));
                }
            }

            return this.sorting.list;
        }
    },

    methods: {
        $_sortingMixin_getListElementField(listElement) {
            let result = listElement;

            if (this.sorting.fieldName === "" || this.sorting.fieldName === null) {
                return result;
            }

            if (this.sorting.fieldName.indexOf(".") < 0) {
                return result[this.sorting.fieldName];
            }

            const fields = this.sorting.fieldName.split(".");

            for (let i = 0; i < fields.length; i++) {
                result = result[fields[i]];
            }

            return result;
        },

        $_sortingMixin_getColumnElement(listElement) {
            if (this.sorting.fieldFunction === null) {
                return this.$_sortingMixin_getListElementField(listElement);
            }

            return this.sorting.fieldFunction(this.$_sortingMixin_getListElementField(listElement));
        },

        changeSorting(fieldName, fieldType, fieldFunction) {
            if (this.sorting.fieldName === fieldName) {
                this.sorting.isAscending = !this.sorting.isAscending;
            } else {
                this.sorting.fieldName = fieldName;
                this.sorting.fieldType = fieldType;
                this.sorting.fieldFunction = fieldFunction;
                this.sorting.isAscending = true;
            }
        },

        resetSorting() {
            this.changeSorting("", "", null);
        }
    }
};